module.exports = __webpack_public_path__ + "摘要.png?a9e4dddaa2c1525110665fbf151d3c73";


//////////////////
// WEBPACK FOOTER
// ./src/assets/摘要.png
// module id = 705
// module chunks = 0